export class Accounts {
  abosAccountId: string;
  abosAccountName: string | null;
  bitfinexAccountId: number | string | null;
  bitfinexAccountName: string | null;

  constructor(abosAccountId: string, abosAccountName: string | null, bitfinexAccountId: number | string | null) {
    this.abosAccountId = abosAccountId;
    this.abosAccountName = abosAccountName;
    this.bitfinexAccountId = bitfinexAccountId;
  }
}
